export const environment = {
  production: true,
  baseApiUrl: 'https://sc-api-t.rw3.app/',
  baseAppUrl: 'https://sc-t.rw3.app/',
  env: 'test'
};
